
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z"}}),_c('path',{attrs:{"d":"M7.5 10C6.673 10 6 9.327 6 8.5S6.673 7 7.5 7 9 7.673 9 8.5 8.327 10 7.5 10zm0-2a.5.5 0 100 1 .5.5 0 000-1zm9 2c-.827 0-1.5-.673-1.5-1.5S15.673 7 16.5 7s1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2a.5.5 0 100 1 .5.5 0 000-1zM12 19a6.976 6.976 0 01-5.893-3.23.5.5 0 11.842-.54A5.982 5.982 0 0012 18a5.982 5.982 0 005.051-2.77.5.5 0 11.842.54A6.976 6.976 0 0112 19z"}})])
          )
        }
      }
    